import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { QuoteInputForm, QuoteLeadOriginEnum, QuoteLeadOutputV5, QuoteOutput, QuoteRequest } from '@lx/quote-tool/shared/types';
import { map, switchMap } from 'rxjs/operators';
import { QuoteService } from '@lx/quote-tool/shared/data-access/quote';
import { Language, LanguageService } from '@lx/language';
import { Clipboard } from '@angular/cdk/clipboard';
import { MessageService } from 'primeng/api';
import { INFO_TOAST_KEY } from '../constants/toast.constants';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { QuoteInputFormMapper } from '@lx/quote-tool/form';

@Injectable({
  providedIn: 'root',
})
export class ArgoService {
  private readonly languageService = inject(LanguageService);
  private readonly quoteService = inject(QuoteService);
  private readonly quoteInputFormMapper = inject(QuoteInputFormMapper);

  private readonly clipboard = inject(Clipboard);
  private readonly messageService = inject(MessageService);

  sendLeadToArgo(quoteOutput: QuoteOutput, orderId?: number): Observable<number> {
    const {
      input,
      input: { exchangeCurrencyCode, languageCode },
      quoteId,
    } = quoteOutput;
    return this.languageService.getByCode(languageCode).pipe(
      map(({ name: courseLanguage }: Language) => {
        return {
          ...this.quoteInputFormMapper.mapQuoteInputFormToQuoteRequestDto(<QuoteInputForm>input),
          courseLanguage,
          exchangeCurrencyCode,
        };
      }),
      switchMap((quoteRequest: QuoteRequest) => {
        return this.quoteService.createLeadV2({
          id: orderId,
          quoteRequest: [{ ...quoteRequest, quoteId }],
          formOrigin: QuoteLeadOriginEnum.ARGO_QUICK_QUOTE_TOOL,
        });
      }),
      switchMap((quoteLeadOutput: QuoteLeadOutputV5) => {
        return of(parseInt(quoteLeadOutput?.message));
      }),
    );
  }

  copyIdToClipboard(argoId: string) {
    const successfullyOperation = this.clipboard.copy(argoId);
    if (successfullyOperation) {
      this.messageService.add({
        severity: 'success',
        key: INFO_TOAST_KEY,
        summary: $localize`Successfully copied to clipboard`,
        detail: $localize`ARGO ID: ${argoId}`,
      });
    }
  }
}
